import { render, staticRenderFns } from "./dyjyMuBan.vue?vue&type=template&id=e631b326&scoped=true"
import script from "./dyjyMuBan.vue?vue&type=script&lang=js"
export * from "./dyjyMuBan.vue?vue&type=script&lang=js"
import style0 from "./dyjyMuBan.vue?vue&type=style&index=0&id=e631b326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e631b326",
  null
  
)

export default component.exports